module.exports = "/assets/data/8380f802e8cfe211b5c6291703bb1b4a-RM7.data.json";